import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps } from '@gitbook/spine-react';

import {
    type UseSetDefaultSiteVariantProps,
    useSetDefaultSiteVariant,
} from './useSetDefaultSiteVariant';

interface SetVariantAsDefaultButtonProps
    extends UseSetDefaultSiteVariantProps,
        Pick<ButtonProps, 'className' | 'label' | 'size'> {
    siteSpace: api.SiteSpace;
}

export function SetVariantAsDefaultButton(props: SetVariantAsDefaultButtonProps) {
    const { className, label, size, siteSpace } = props;
    const setAsDefault = useSetDefaultSiteVariant(props);
    return (
        <Button
            kind="secondary"
            leadingIcon={Icon.Home}
            onPress={() => setAsDefault(siteSpace)}
            disabled={Boolean(siteSpace.hidden)}
            label={label}
            tooltip={
                siteSpace.hidden
                    ? {
                          label: 'Hidden variants cannot be set as home.',
                      }
                    : undefined
            }
            className={className}
            size={size}
        />
    );
}
